import { Accordion } from "@components/shared/Accordion";
import { Product, ProductIcon } from "@components/shared/ProductIcon";
import { Section, SectionHeading } from "@components/shared/Section";
import { useTranslations } from "@services/strings";

/** The help centre's categories: General, then one per product. */
export type HelpCategoryId = "general" | Product;

/** What the category shows of an article; a contentlayer FaqDocument fits. */
type Article = { slug: string; title: string; body: { html: string } };

/**
 * One help-centre category: its name beside its articles, each opening in
 * place like the FAQ block on the landing pages.
 */
export const HelpCategory = ({
  category,
  faqDocuments,
  tone = "white",
}: {
  category: HelpCategoryId;
  faqDocuments: Article[];
  tone?: "white" | "mist";
}) => {
  const { t } = useTranslations();

  if (faqDocuments.length === 0) {
    return null;
  }

  return (
    <Section id={category} tone={tone} tight>
      <div className="grid gap-10 md:grid-cols-[0.8fr_1.2fr] md:gap-16">
        <div className="flex items-center gap-4 self-start">
          {category === "general" ? null : <ProductIcon product={category} />}
          <SectionHeading title={t(`pages.help.categories.${category}`)} />
        </div>
        <Accordion
          items={faqDocuments.map((faq) => ({
            id: faq.slug,
            question: faq.title,
            html: faq.body.html,
          }))}
        />
      </div>
    </Section>
  );
};
